import { useAtomValue } from "jotai";
import { useNotificationCenterRightOptional } from "web_myplann/Api/Rights/RightsProvider";
import { useContractsSectionDerivation } from "web_myplann/More/NotificationSettings/Hooks/useContractsSectionDerivation";
import { rightsState } from "web_myplann/Shared/State/rightsAtom";

type NotificationSettingsAccess = {
	/** True while rights or (enabled) settings query has no first result yet — a disabled query stays pending forever. */
	isLoading: boolean;
	/** True only when a query failed and has nothing to show. */
	isError: boolean;
	isMenuItemVisible: boolean;
	isPageAccessible: boolean;
	isBannerVisible: boolean;
	isSectionVisible: boolean;
};

export const useNotificationSettingsAccess = (): NotificationSettingsAccess => {
	const rights = useAtomValue(rightsState);

	const hasNotificationCenterRight = useNotificationCenterRightOptional();

	const contracts = useContractsSectionDerivation();

	const isMenuItemVisible =
		hasNotificationCenterRight && contracts.isSectionVisible;

	return {
		isLoading:
			rights === undefined ||
			(hasNotificationCenterRight && contracts.isPending),
		// Rights have no error state — RightsProvider falls back to NO_PILOT_RIGHTS.
		isError: contracts.isError && !contracts.hasData,
		isMenuItemVisible,
		isPageAccessible: isMenuItemVisible,
		isBannerVisible: contracts.isBannerVisible,
		isSectionVisible: contracts.isSectionVisible,
	};
};
